import styled from 'styled-components'

export const PaginationContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    /* margin-left: 20px; */
    justify-content: space-around;
    width: 100%;

    .form-group {
        margin-bottom: 0;
    }

    input {
        background: ${({ theme }) => theme['gray-0']};
    }
`

export const Search = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    margin: 0;

    .filteredSearch-input {
        border-radius: 3px;
        border: 1px solid var(--gray-400);
        width: 100%;
        cursor: text;

        i {
            color: var(--gray-600);
            padding: 8px;
            cursor: pointer;
            z-index: 1;
        }

        input {
            border: none;
            color: var(--gray-1000);
            padding: 8px;
            width: calc(100% - 28px);
            border-radius: 3px;
            background: var(--gray-0);
        }
    }

    .filteredSearch-filter {
        height: 36px;

        i.custom-filter {
            position: absolute;
            top: 13px;
            z-index: 1;
            padding-left: 8px;
            padding-right: 4px;
            color: var(--blue-500);
        }

        .live-dropdown-button {
            height: 36px;
            padding-left: 24px;
            border-radius: 3px;
            background: var(--gray-0);
            border-color: var(--gray-400);
        }

        ul {
            z-index: 1;
        }
    }
`

export const SelectLimitPagination = styled.div`
    min-width: 180px;
    max-width: 180px;
    margin-right: 16px;
    margin-left: 16px;
`

export const ListButtonsPagination = styled.ul`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;

    li + li {
        margin-left: 5px;
    }

    button {
        border: none;
        background: transparent;
        color: ${({ theme }) => theme['gray-800']};
        font-size: 13px;
        font-weight: 400;
    }

    .active-page {
        background: transparent;
        color: ${({ theme }) => theme['blue-500']};
        font-weight: 600;
    }

    .active-page:focus {
        outline: none;
    }

    .reticence {
        display: flex;
        flex-direction: row;
        width: 15px;
        height: 3px;
        justify-content: space-between;
        margin: 0 8px;
    }

    .circle {
        width: 3px;
        height: 3px;
        background: ${({ theme }) => theme['gray-300']};
        border-radius: 3px;
    }

    .live-select {
        margin: 0;
        width: 144px;
        margin-left: 20px;
        color: ${({ theme }) => theme['gray-0']};

        #react-select-2--value-item {
            color: ${({ theme }) => theme['gray-0']};
        }
    }
`
